!function() {
  class t extends HTMLElement {
    hoverButton=null;
    isHovering=!1;
    cursorPosition={
      x: 0,
      y: 0
    };
    isTicking=!1;
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      this.createHoverButton(), this.addEventListener("mouseenter", this.handleMouseEnter.bind(this)), 
      this.addEventListener("mouseleave", this.handleMouseLeave.bind(this)), this.addEventListener("mousemove", this.handleMouseMove.bind(this));
    }
    createHoverButton() {
      this.hoverButton = document.createElement("div");
      const t = this.getAttribute("button-text"), i = this.getAttribute("button-class");
      this.hoverButton.className = `\n      fixed z-50 cursor-pointer transition-opacity opacity-0 pointer-events-none\n      ${i || ""}\n    `.trim(), 
      this.hoverButton.textContent = t || "", document.body.appendChild(this.hoverButton);
    }
    handleMouseEnter() {
      this.showButton();
    }
    handleMouseLeave() {
      this.hideButton();
    }
    showButton() {
      this.isHovering = !0, this.hoverButton.classList.remove("opacity-0"), this.hoverButton.classList.add("opacity-100");
    }
    hideButton() {
      this.isHovering = !1, this.hoverButton.classList.add("opacity-0"), this.hoverButton.classList.remove("opacity-100");
    }
    handleMouseMove(t) {
      this.cursorPosition.x = t.clientX, this.cursorPosition.y = t.clientY - 10, this.requestTick(), 
      t.target.closest("[data-cursor-hide]") ? this.hideButton() : this.showButton();
    }
    requestTick() {
      this.isTicking || (requestAnimationFrame(this.updateButtonPosition.bind(this)), 
      this.isTicking = !0);
    }
    updateButtonPosition() {
      if (this.isTicking = !1, this.isHovering && this.hoverButton) {
        const t = 20, i = 0;
        this.hoverButton.style.left = `${this.cursorPosition.x + t}px`, this.hoverButton.style.top = `${this.cursorPosition.y + i}px`;
      }
    }
    disconnectedCallback() {
      this.hoverButton && this.hoverButton.remove();
    }
  }
  customElements.define("cursor-button", t);
}();